function convertNodeListToArray(list) {
    return [].slice.call(list);
}

function find(selector, element = document) {
    return element.querySelector(selector);
}

function findAll(selector, element = document) {
    return convertNodeListToArray(element.querySelectorAll(selector));
}

module.exports = { find, findAll };



// WEBPACK FOOTER //
// ./src/js/find.js